// Vendors
import React, { useState } from 'react';
import { Panel, ClearRefinements } from 'react-instantsearch-dom';
import classnames from 'classnames';

// Components
import { RefinementList } from '..';

const Facet = ({ id, title, attribute_name }) => {
  const [refinementShow, setRefinementShow] = useState(true);
  const panelClassNames = classnames('product-sidebar__title', {
    [`toggle__switch--on`]: refinementShow
  });

  return (
    <Panel
      id={`facets-${id}`}
      className={`product-sidebar__facet product-sidebar__facet-${id}`}
    >
      <div className="product-sidebar__facet-title u--margin-top-20">
        <h6
          className={panelClassNames}
          onClick={() => setRefinementShow(!refinementShow)}
        >
          Filter by {title}
        </h6>
      </div>
      <div className="form__field">
        <RefinementList
          attribute={`facets.${attribute_name}`}
          showMore={true}
          showMoreLimit={30}
          operator="or"
        />
      </div>
      <ClearRefinements
        transformItems={(items) =>
          items.filter(
            ({ attribute }) => attribute == `facets.${attribute_name}`
          )
        }
        translations={{
          reset: 'Clear Filters'
        }}
      />
    </Panel>
  );
};

export default Facet;
